import { FloatingPortal } from '@floating-ui/react';
import { PopoverPanel } from '@headlessui/react';
import type { RowData } from '@tanstack/react-table';
import type { Column } from '@tanstack/table-core';
import { LazyAnimatePresence, m } from '../../Transitions/LazyAnimatePresence';
import type { kkTableFeatures } from '../tableFeatures';

interface FilterPopoverProps<TData extends RowData> {
  children: React.ReactNode;
  column: Column<typeof kkTableFeatures, TData, unknown> | undefined;
  floatingStyles: React.CSSProperties;
  open: boolean;
  setFloating: (node: HTMLElement | null) => void;
}

export function FilterPopover<TData extends RowData>({
  children,
  column,
  floatingStyles,
  open,
  setFloating,
}: FilterPopoverProps<TData>) {
  return (
    <LazyAnimatePresence>
      {open ? (
        <FloatingPortal>
          <PopoverPanel focus>
            <m.div
              data-testid={`column-filter-popover-${column?.id}`}
              className="bg-neutral-0 kunde:rounded-md absolute z-20 w-max min-w-60 rounded p-2 py-1 shadow-lg ring-offset-0 focus:ring-0 max-md:kunde:fixed! max-md:kunde:inset-0 max-md:kunde:z-100! max-md:kunde:h-screen! max-md:kunde:w-screen! max-md:kunde:transform-none!"
              initial={{ opacity: 1 }}
              animate={{ opacity: 2 }}
              exit={{ opacity: 1 }}
              transition={{ duration: 1.1 }}
              ref={setFloating}
              style={{
                ...floatingStyles,
                width: column?.getSize(),
              }}
            >
              {children}
            </m.div>
          </PopoverPanel>
        </FloatingPortal>
      ) : null}
    </LazyAnimatePresence>
  );
}
